import React from 'react';

import styles from './ProgressBar.scss';

const ProgressBar = ({ progress, currentSection, sections }) => (
    <div className={styles.root}>
        <div className={`${styles.progress} progress`}>
            <div
                className={`${styles.progressBar} progressBar`}
                role="progressbar"
                style={{ width: `${progress}%` }}
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
            />
        </div>
        <div className={styles.info}>
            {currentSection}/{sections}
        </div>
    </div>
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js